<template>
  <nav class="navbar navbar-expand-md navbar-light fixed-top bg-light" id="mainNavbar">
    <a class="navbar-brand d-flex align-items-baseline" href="#"><img src="../../assets/images/logo.png" alt="J" style="max-height: 30px;" class="d-inline-block align-top"/> eisson</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarCollapse" v-spy>
      <ul class="navbar-nav ml-5 ml-sm-0">
        <li class="nav-item">
          <a class="nav-link" href="#home" @click="anchorSoftAnimation"><i class="fas fa-home active"></i> {{ $t('section.home') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#about" @click="anchorSoftAnimation"><i class="fas fa-address-card"></i> {{ $t('section.about') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#projects" @click="anchorSoftAnimation"><i class="fas fa-project-diagram"></i> {{ $t('section.projects') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#technologies" @click="anchorSoftAnimation"><i class="fas fa-cogs"></i> {{ $t('section.technologies') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#contact" @click="anchorSoftAnimation"><i class="fas fa-envelope"></i> {{ $t('section.contact') }}</a>
        </li>
      </ul>
      <div class="ml-5">
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="es" name="locale" class="custom-control-input" value="es" v-model="locale">
          <label class="custom-control-label" for="es" style="cursor: pointer;" title="Español"><img src="../../assets/images/es.png" alt="Es" /></label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="en" name="locale" class="custom-control-input" value="en" v-model="locale">
          <label class="custom-control-label" for="en" style="cursor: pointer;" title="English"><img src="../../assets/images/en.png" alt="En" /></label>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import animationsMixin from '@/mixins/animations'

export default {
  mixins: [ animationsMixin ],
  name: 'Navbar',
  data: () => ({
    menuVisible: false,
    locale: 'en'
  }),
  mounted () {
    this.locale = this.$i18n.locale
  },
  watch: {
    locale (newLocale) {
      this.$i18n.locale = newLocale
    }
  },
  directives: {
    spy: {
      // directive definition
      inserted (el) {
        let lastId
        let topMenu = window.jQuery(el)
        // All list items
        let menuItems = topMenu.find('a')
        // Anchors corresponding to menu items
        let scrollItems = menuItems.map((i, menuItem) => {
          let $item = window.jQuery(menuItem)
          $item.on('click', () => {
            topMenu.collapse('hide')
          })

          let id = $item.attr('href')
          let item = window.jQuery(id)
          if (item.length) {
            return item
          }
        })

        // Bind to scroll
        window.jQuery(window).scroll(() => {
          // Get container scroll position
          let fromTop = window.jQuery(window).scrollTop() + 56

          // Get id of current scroll item
          let cur = scrollItems.map((i, item) => {
            if (window.jQuery(item).offset().top <= fromTop) {
              return item
            }
          })

          // Get the id of the current element
          cur = cur[cur.length - 1]
          let id = cur && cur.length ? cur[0].id : ''

          if (lastId !== id) {
            lastId = id
            // Set/remove active class
            menuItems
              .parent().removeClass('active')
              .end().filter("[href='#" + id + "']").parent().addClass('active')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  .custom-control-label:hover {
    border-radius: 50%;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
  }

  .navbar-brand:hover {
    text-shadow: 2px 2px 6px rgba(150, 150, 150, 0.7);
  }
</style>
